export default {
    topics: [
        {
            title: 'Database',
            href: 'f-sqlExec.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4322',
            next: 'tocId-d66e4322',
        },
        {
            title: 'File',
            href: 'f-loadString.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4452',
            next: 'tocId-d66e4452',
        },
        {
            title: 'Log',
            href: 'f-logInfo.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4541',
            next: 'tocId-d66e4541',
        },
        {
            title: 'Miscellaneous',
            href: 'f-loadLibrary.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4574',
            next: 'tocId-d66e4574',
        },
        {
            title: 'System',
            href: 'f-sleep.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4833',
            next: 'tocId-d66e4833',
        },
        {
            title: 'Workflow',
            href: 'f-getEventFromTransition.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4866',
            next: 'tocId-d66e4866',
        },
    ],
};

